import React from 'react';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import moment from 'moment';
import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@cargomatic/ui';
import Pagination from 'components/v2/Pagination';

export default function LaneRateAuditTable({
  items,
  perPage,
  page,
  pages,
  total,
  onPageClick,
  loading,
}) {
  const { t } = useTranslation();

  function handlePageClick(selectedPage) {
    onPageClick(selectedPage);
  }

  function renderLane(item) {
    return (
      <div className="flex flex-col whitespace-nowrap text-sm">
        <p>
          <span className="font-medium">{titleize(t('ORIGIN'))}:</span>{' '}
          {item.originCity} - {item.originZip}
        </p>
        <p>
          <span className="font-medium">{titleize(t('DESTINATION'))}:</span>{' '}
          {item.destinationCity} - {item.destinationZip}
        </p>
      </div>
    );
  }

  function renderTimestamp(createdAt) {
    if (!createdAt || !moment(createdAt).isValid()) {
      return t('INVALID_DATE');
    }
    return moment(createdAt).format('YYYY-MM-DD HH:mm:ss');
  }

  const COLUMN_COUNT = 5;

  return (
    <div className="overflow-x-auto w-full">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>{t('CUSTOMER')}</TableHead>
            <TableHead>{t('LANE')}</TableHead>
            <TableHead>{t('EVENT')}</TableHead>
            <TableHead>{t('TIMESTAMP')}</TableHead>
            <TableHead>{t('SOURCE')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {loading
            ? Array.from({ length: 5 }).map((_, i) => (
                <TableRow key={i}>
                  {Array.from({ length: COLUMN_COUNT }).map((_, colIdx) => (
                    <TableCell key={colIdx}>
                      <Skeleton className="h-4 w-full" />
                    </TableCell>
                  ))}
                </TableRow>
              ))
            : items.map((item, i) => (
                <TableRow key={i}>
                  <TableCell>{item.customer}</TableCell>
                  <TableCell>{renderLane(item)}</TableCell>
                  <TableCell>{item.message}</TableCell>
                  <TableCell className="whitespace-nowrap">
                    {renderTimestamp(item.createdAt)}
                  </TableCell>
                  <TableCell>{item.user}</TableCell>
                </TableRow>
              ))}
        </TableBody>
      </Table>
      <Pagination
        dataTestId="Pagination-443d293c"
        className="border-none"
        perPage={perPage}
        page={page}
        pages={pages}
        total={total}
        showCount
        paginationContainerClassName="mx-auto my-0 sticky right-2/4"
        onPageClick={handlePageClick}
      />
    </div>
  );
}
